import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

export const PageViewTracker = () => {
  const { pathname } = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    if (pathname.startsWith("/admin") || lastTracked.current === pathname) return;
    lastTracked.current = pathname;
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/pageview`, { path: pathname }).catch(() => {});
  }, [pathname]);

  return null;
};
